import React, { useState, useEffect } from 'react';
import Box from '../../../hoc/Box/Box';

const DeviceSterringCountDownTimer = ({ expiresAt, handleTimeEnd = () => { } }) => {
  const [displayTime, setDisplayTime] = useState({ minutes: null, seconds: null });
  const updateTime = () => {
    const tn = Math.floor(new Date().getTime() / 1000); // Time Now (in seconds)
    const te = Math.floor(new Date(expiresAt).getTime() / 1000); // Time at the End of steering (in seconds)
    const tr = te - tn; // Time Remaining (in seconds)
    if (tr < 0) return; // (negative time remaining implies end time has passed.)

    const timePaddedWithZeroes = {
      minutes: String(Math.floor(tr / 60)).padStart(2, '0'),
      seconds: String(tr % 60).padStart(2, '0'),
    }
    setDisplayTime(timePaddedWithZeroes)
  }

  useEffect(() => {
    updateTime()
  }, []);

  useEffect(() => {
    const { minutes, seconds } = displayTime
    if (minutes === '00' && seconds === '00') {
      setTimeout(() => {
        handleTimeEnd();
      }, 2000);
    }
  }, [displayTime])

  useEffect(() => {
    let myInterval = setInterval(() => {
      updateTime()
    }, 1000)
    return () => {
      clearInterval(myInterval);
    };
  });

  const { minutes, seconds } = displayTime
  return (
    <Box>
      {minutes === '00' && seconds === '00'
        ? '00:00'
        : <span>{minutes}:{seconds}</span>
      }
    </Box>
  )
}

export default DeviceSterringCountDownTimer;